
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-accessibility-statement",
      function () {
        return require("private-next-pages/web-accessibility-statement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-accessibility-statement"])
      });
    }
  